export const applicationRouteNames = {
  dashboard: 'dashboard',
  administration: 'administration',
  users: 'users',
  lokalise: 'lokalise',
  orgEntities: 'org-entities',
  usersRoles: 'roles',
  sync: 'sync',
  workflows: 'workflows',
};
